import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getTrade } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";

const PercentageOptions = () => {
    const web3 = useWeb3();

    const PercentageOptionsHook = useCallback(
        async (address, choiceIndexes) => {
            const contract = getTrade(address, web3);
            try {
                const percentages = await Promise.all(
                    choiceIndexes?.map(async (choiceIndex) => {
                        try {
                            const percentageOption = await contract.methods.totalVotes(choiceIndex).call();             
                           
                            return { choiceIndex, percentageOption };
                        } catch (error) {
                            console.error(`Error fetching percentage for choiceIndex ${choiceIndex}:`, error.message || error);
                            return null;
                        }
                    })
                );
                return percentages.filter(item => item !== null);
            } catch (error) {
                console.error("Error fetching percentages:", error.message || error);
                throw error;
            }
        },
        [web3]
    );

    return { PercentageOptionsHook };
};

export default PercentageOptions;
